// US State name to abbreviation mapping
const US_STATE_NAME_TO_ABBR = {
  'ALABAMA': 'AL', 'ALASKA': 'AK', 'ARIZONA': 'AZ', 'ARKANSAS': 'AR', 'CALIFORNIA': 'CA',
  'COLORADO': 'CO', 'CONNECTICUT': 'CT', 'DELAWARE': 'DE', 'FLORIDA': 'FL', 'GEORGIA': 'GA',
  'HAWAII': 'HI', 'IDAHO': 'ID', 'ILLINOIS': 'IL', 'INDIANA': 'IN', 'IOWA': 'IA',
  'KANSAS': 'KS', 'KENTUCKY': 'KY', 'LOUISIANA': 'LA', 'MAINE': 'ME', 'MARYLAND': 'MD',
  'MASSACHUSETTS': 'MA', 'MICHIGAN': 'MI', 'MINNESOTA': 'MN', 'MISSISSIPPI': 'MS', 'MISSOURI': 'MO',
  'MONTANA': 'MT', 'NEBRASKA': 'NE', 'NEVADA': 'NV', 'NEW HAMPSHIRE': 'NH', 'NEW JERSEY': 'NJ',
  'NEW MEXICO': 'NM', 'NEW YORK': 'NY', 'NORTH CAROLINA': 'NC', 'NORTH DAKOTA': 'ND', 'OHIO': 'OH',
  'OKLAHOMA': 'OK', 'OREGON': 'OR', 'PENNSYLVANIA': 'PA', 'RHODE ISLAND': 'RI', 'SOUTH CAROLINA': 'SC',
  'SOUTH DAKOTA': 'SD', 'TENNESSEE': 'TN', 'TEXAS': 'TX', 'UTAH': 'UT', 'VERMONT': 'VT',
  'VIRGINIA': 'VA', 'WASHINGTON': 'WA', 'WEST VIRGINIA': 'WV', 'WISCONSIN': 'WI', 'WYOMING': 'WY',
  'DISTRICT OF COLUMBIA': 'DC'
};

// Helper function to get state abbreviation from state name or code
const getStateAbbreviation = (state) => {
  if (!state) return '';

  // Handle object { code, name } or plain string
  const raw = typeof state === 'object'
    ? (state.code || state.name || '')
    : String(state);

  const cleaned = raw.trim().replace(/\./g, '');
  if (!cleaned) return '';

  // If already a 2-letter code, return uppercase
  if (/^[A-Za-z]{2}$/.test(cleaned)) {
    return cleaned.toUpperCase();
  }

  // Try to map full state name to abbreviation
  const normalized = cleaned.toUpperCase().replace(/\s+/g, ' ');
  return US_STATE_NAME_TO_ABBR[normalized] || cleaned;
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

      // Reset time to compare dates only
      const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const yesterdayOnly = new Date(
        yesterday.getFullYear(),
        yesterday.getMonth(),
        yesterday.getDate()
      );

      const timeString = date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
      });

      if (dateOnly.getTime() === todayOnly.getTime()) {
        return `Today, ${timeString}`;
      } else if (dateOnly.getTime() === yesterdayOnly.getTime()) {
        return `Yesterday, ${timeString}`;
      } else {
        // Use existing format for older dates
        return date.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
        });
      }
}

const getPropertyAddress = (assignment) => {
  const pa = assignment?.propertyAddress;
  if (!pa) return '';

  const stateAbbr = getStateAbbreviation(pa.state);

  const parts = [
    pa.address1?.trim(),
    pa.address2?.trim(),
    pa.city?.trim(),
    stateAbbr,
    pa.postalCode?.trim(),
  ].filter(Boolean);

  if (parts.length === 0) return '';

  return parts.join(', ');
}

const getPropertyName = (assignment) => {
  const pa = assignment?.propertyAddress;
  if (!pa) return '';

  const propertyName = pa.propertyName?.trim();

  const stateAbbr = getStateAbbreviation(pa.state);

  const parts = [
    pa.address1?.trim(),
    pa.address2?.trim(),
    pa.city?.trim(),
    stateAbbr,
    pa.postalCode?.trim(),
  ].filter(Boolean);

  if (!propertyName && parts.length === 0) return '';

  return propertyName ? propertyName : parts.join(', ');
}

const getPropertyAddressOrName = (assignment, needPropertyName = false) => {
  const pa = assignment?.propertyAddress;
  if (!pa) return '';

  const propertyName = pa.propertyName?.trim();

  if(needPropertyName && propertyName) {
    return propertyName;
  }

  const stateAbbr = getStateAbbreviation(pa.state);

  const parts = [
    pa.address1?.trim(),
    pa.address2?.trim(),
    pa.city?.trim(),
    stateAbbr,
  ].filter(Boolean);

  if (!propertyName && parts.length === 0) return '';

  return parts.join(', ');
}

  const getWorkfileId = (value) => {
  if (!value) return null
  let arr
  if (value.includes('?')) {
    let boxArr = value.split('?')
    arr = boxArr[0].split('/')
  } else {
    arr = value.split('/')
  }
  return arr && arr.length > 0 ? arr[arr.length - 1] : null
}

export {
    formatDate,
    getPropertyAddress,
    getWorkfileId,
    getPropertyAddressOrName,
    getPropertyName,
}